import fr from '@/i18n/fr'
import en from '@/i18n/en'
import { createI18n } from 'vue-i18n'

export const localI18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: 'en',
  locale: navigator.language.substring(0,2), // we take only 'fr' / 'en', ...
  messages: {
    fr,
    'fr-BE': fr,
    'fr-CA': fr,
    'fr-CH': fr,
    'fr-FR': fr,
    'fr-LU': fr,
    'fr-MC': fr,
    en,
  },
})
